/**
 * TWA Theme - Trans World Airlines Inspired Theme
 * Classic light theme with red accents
 */

import type { ThemeConfig } from 'antd';

/**
 * TWA Theme Color Tokens
 */
export const TWA_THEME_TOKENS = {
	// Base colors
	fontSize: 10,
	fontFamily:
		"'Avenir Next LT Pro', AvenirNextLTPro, 'Avenir Next', Avenir, -apple-system, sans-serif",
	colorBgBase: '#ffffff', // White background
	colorTextBase: '#000000', // Black text
	colorBorder: '#d9d9d9', // Light gray border
	controlOutline: 'transparent',
	controlOutlineWidth: 0,

	// Primary colors - TWA Red
	colorPrimary: '#C8102E',
	colorPrimaryHover: '#E01E37',
	colorPrimaryActive: '#A00D25',

	// Link colors - TWA Red
	colorLink: '#C8102E',
	colorLinkHover: '#E01E37',
	colorLinkActive: '#A00D25',

	// Layout
	borderRadius: 0,
} as const;

/**
 * TWA Theme Component Customizations
 */
export const TWA_COMPONENTS: ThemeConfig['components'] = {
	Button: {
		// Primary button - TWA Red
		colorPrimary: '#C8102E',
		colorTextLightSolid: '#ffffff',
		primaryShadow: '0 2px 4px rgba(200,16,46,0.2)',
		colorPrimaryHover: '#E01E37',
		colorPrimaryActive: '#A00D25',

		// Default button
		colorBgContainer: '#ffffff',
		colorBorder: '#d9d9d9',
		colorText: '#000000',
		defaultHoverBg: '#f5f5f5',
		defaultHoverColor: '#000000',
		defaultActiveBg: '#e8e8e8',
	},
	Modal: {
		contentBg: '#ffffff',
		headerBg: '#ffffff',
		titleColor: '#000000',
		colorText: '#000000',
	},
	Input: {
		colorBgContainer: '#ffffff',
		colorText: '#000000',
		colorBorder: '#d9d9d9',
		activeShadow: '0 0 0 2px rgba(200,16,46,0.2)',
		colorTextPlaceholder: '#8c8c8c',
		hoverBorderColor: '#C8102E',
		activeBorderColor: '#C8102E',
	},
	Select: {
		hoverBorderColor: '#C8102E',
		activeBorderColor: '#C8102E',
	},
	DatePicker: {
		hoverBorderColor: '#C8102E',
		activeBorderColor: '#C8102E',
	},
	Form: {
		labelColor: '#000000',
		colorText: '#000000',
	},
	Table: {
		colorBgContainer: '#ffffff',
		headerColor: '#000000',
		headerBg: '#fafafa',
	},
	Card: {
		colorBgContainer: '#ffffff',
	},
	Checkbox: {
		colorPrimary: '#C8102E', // TWA Red
		colorPrimaryHover: '#E01E37',
		borderRadius: 4,
		colorWhite: '#ffffff',
	},
	Menu: {
		itemBg: '#ffffff',
		itemSelectedBg: '#C8102E',
		itemSelectedColor: '#ffffff',
	},
};

/**
 * TWA Layout Colors
 */
export const TWA_LAYOUT_COLORS = {
	navbar: {
		background: '#C8102E', // TWA Red navbar
		height: '50px',
		boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
	},
	content: {
		background: '#f5f5f5', // Light gray background
		marginTop: 35,
		paddingVertical: 24,
	},
	layout: {
		background: '#f5f5f5', // Light gray background
		minHeight: '100vh',
	},
} as const;
